import { useMemo, useContext, useState, useEffect } from "react";

import { useWritePolicyIds } from "@modules/cve/hooks";

import { ReactTable } from "@shared/components";

import { PoliciesContext } from "@modules/cve/context";
import { PoliciesTableColumns, defaultColumnVisability, PoliciesTableRowActions, PolicyFormModal } from "@modules/cve/components";

export const PoliciesTable = () => {
	const [openModal, setOpenModal] = useState(false);
	const [viewOnly, setViewOnly] = useState(false);
	const [columnVisibility, setColumnVisibility] = useState(defaultColumnVisability);
	const { policies } = useContext(PoliciesContext);
	const columns = useMemo(PoliciesTableColumns, [policies]);
	const { writePolicyIds } = useWritePolicyIds();

	useEffect(() => {
		try {
			let userDefaultColumns = JSON.parse(localStorage.getItem("cvePoliciesColumnVisibility"));
			if (userDefaultColumns) setColumnVisibility(userDefaultColumns);
		} catch (error) {
			localStorage.removeItem("cvePoliciesColumnVisibility");
		}
	}, []);

	const handleColumnChange = (newColumnVisibility) => {
		setColumnVisibility((prevState) => {
			let newVisibilityState = { ...prevState, ...newColumnVisibility() };
			localStorage.setItem("cvePoliciesColumnVisibility", JSON.stringify(newVisibilityState));
			return newVisibilityState;
		});
	};

	return (
		<>
			<ReactTable
				id="cvePoliciesTable"
				data={policies}
				columns={columns}
				initialState={{ sorting: [{ id: "name" }] }}
				state={{ columnVisibility }}
				onColumnVisibilityChange={handleColumnChange}
				enableStickyHeader
				enableRowActions
				displayColumnDefOptions={{
					"mrt-row-actions": {
						header: " ",
					},
				}}
				renderRowActionMenuItems={({ row, closeMenu }) => (
					<PoliciesTableRowActions row={row} hasWriteAccess={writePolicyIds.includes(row.original.policyId)} closeMenu={closeMenu} setOpenModal={setOpenModal} setViewOnly={setViewOnly} />
				)}
			/>
			<PolicyFormModal
				viewOnly={viewOnly}
				open={openModal}
				onClose={() => {
					setOpenModal(false);
					setViewOnly(false);
				}}
			/>
		</>
	);
};
